<ng-container *ngIf="initialize">
<div class="hp-page">
  <div class="hp-outer">

    <!-- Title -->
    <div class="hp-title">
      <h1>Health Picks</h1>
      <p>製品管理画面</p>
    </div>

    <!-- Card -->
    <div class="hp-card">
      <h2>ロックを解除しました</h2>

      <p class="hp-countdown">
        {{ countdown }}秒後に、{{ appname }}のトップページへ自動的に移動します。
      </p>

      <p class="hp-note">
        自動的に移動しない場合は、「トップに戻る」ボタンを押してください。
      </p>

      <button class="hp-btn" (click)="redirect()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
        </svg>
        トップに戻る
      </button>
    </div>

  </div>
</div>
</ng-container>
